import { CommonFragments } from './common.fragments';

export class CreditQualityFragments {
  /*
   * GraphQL Fragment for Credit Quality Exhibit
   */
  public static readonly creditQualityFragment = `
    creditQualityExhibit {
      asOfDate
      availablePriorDates
      benchmarkName
      values {
        qualityRating
        percentOfFund
        percentOfIndicativeBenchmark
        percentOfChangeFromLastPeriod
        rank
      }
      ${CommonFragments.disclaimerFragment}
    }
  `;
}
